import { render, staticRenderFns } from "./PaginateAndSortServerSide.vue?vue&type=template&id=e07a40f2&"
import script from "./PaginateAndSortServerSide.vue?vue&type=script&lang=js&"
export * from "./PaginateAndSortServerSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports